import type { EditAreaTemplate } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { EditAreaTemplateSummary } from '@/entities/edit-area-template';
import { Button, cn, tableStyles } from '@/shared/ui';
import { CategorySelect } from './category-select';

interface EditAreaTemplateRowProps {
  readonly template: EditAreaTemplate;
  readonly isPending: boolean;
  readonly onCategoryChange: (template: EditAreaTemplate, categoryId: string | null) => void;
  readonly onRename: (template: EditAreaTemplate) => void;
  readonly onDelete: (template: EditAreaTemplate) => void;
}

/** 템플릿 표의 한 행 — 이름·카테고리 지정·담긴 내용·관리. */
export const EditAreaTemplateRow = ({
  template,
  isPending,
  onCategoryChange,
  onRename,
  onDelete,
}: EditAreaTemplateRowProps): ReactElement => (
  <tr className={cn(tableStyles.row, 'align-top')}>
    <td className={cn(tableStyles.td, 'font-medium')}>{template.name}</td>
    <td className={tableStyles.td}>
      <CategorySelect
        label={`${template.name} 카테고리`}
        value={template.categoryId}
        disabled={isPending}
        onChange={(categoryId) => onCategoryChange(template, categoryId)}
      />
    </td>
    <td className={tableStyles.td}>
      <EditAreaTemplateSummary template={template} />
    </td>
    <td className={tableStyles.td}>
      <div className="flex gap-2">
        <Button size="sm" variant="outline" disabled={isPending} onClick={() => onRename(template)}>
          이름 변경
        </Button>
        <Button size="sm" variant="outline" disabled={isPending} onClick={() => onDelete(template)}>
          삭제
        </Button>
      </div>
    </td>
  </tr>
);
